import type { IBimRelationshipEdge } from '@skystone/shared';
import { cn } from '@/lib/utils';
import { cardinalityLabel } from '@/lib/bim-relationship-utils';

export interface BimRelationshipListProps {
  edges: IBimRelationshipEdge[];
  selectedEdgeId: string | null;
  onSelectEdge: (edgeId: string) => void;
}

const GRID_COLUMNS = 'grid grid-cols-[1.4fr_1.4fr_1.6fr_0.8fr_0.7fr] gap-2';

export function BimRelationshipList({ edges, selectedEdgeId, onSelectEdge }: BimRelationshipListProps) {
  return (
    <div className="rounded-md border border-border bg-card p-4">
      <h3 className="text-sm font-semibold">Relationship List</h3>
      <p className="mt-1 text-xs text-muted-foreground">
        Click a row to highlight that relationship in the graph.
      </p>
      <div className="mt-3 max-h-72 overflow-auto">
        <div className={cn(GRID_COLUMNS, 'sticky top-0 border-b border-border bg-card px-2 py-1 text-xs font-medium')}>
          <span>From</span>
          <span>To</span>
          <span>Key Match</span>
          <span>Cardinality</span>
          <span>Status</span>
        </div>
        {edges.map((edge) => (
          <button
            key={`row-${edge.id}`}
            type="button"
            data-testid={`bim-rel-row-${edge.id}`}
            aria-pressed={selectedEdgeId === edge.id}
            onClick={() => onSelectEdge(edge.id)}
            className={cn(
              GRID_COLUMNS,
              'w-full border-b border-border/60 px-2 py-1 text-left text-xs hover:bg-muted/40',
              selectedEdgeId === edge.id && 'bg-primary/10',
            )}
          >
            <span className="truncate">{edge.fromTable}</span>
            <span className="truncate">{edge.toTable}</span>
            <span className="truncate">{`${edge.fromColumn} -> ${edge.toColumn}`}</span>
            <span>{cardinalityLabel(edge)}</span>
            <span>{edge.isActive ? 'Active' : 'Inactive'}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
